import type { Mode } from '../../lib/types';

export function ModeToggle({ mode, onChange }: { mode: Mode; onChange: (m: Mode) => void }) {
  return (
    <div className="inline-flex rounded border border-[var(--border)] p-0.5">
      {(['bw', 'color'] as const).map((m) => (
        <button
          key={m}
          onClick={() => onChange(m)}
          className={`rounded-sm px-3 py-1 text-sm transition ${mode === m ? 'bg-[var(--content)] font-medium text-[var(--content-fg)]' : 'text-[var(--primary)] hover:bg-[var(--tertiary)]'}`}
        >
          {m === 'bw' ? 'B&W' : 'Color'}
        </button>
      ))}
    </div>
  );
}
